<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>
  <div class="editor-registro">
    <div class="divForm" *ngIf="editRegistroForm">
      <form [formGroup]="editRegistroForm" (onSubmit)="submit()">
        <div class="form-group row">
          <div class="col-sm-12 col-md-6">
            <mat-form-field appearance="outline">
              <mat-select
                placeholder="{{ translation.Fichero }}"
                formControlName="Fichero"
                name="Fichero"
                (selectionChange)="onChangeFichero($event)"
              >
                <mat-option
                  *ngFor="let element of fiecheros"
                  [value]="element"
                >
                  {{ element }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="validateFields('Fichero')">
                {{ getErrorMessage("Fichero") }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="guia-visual-container col-md-3">
            <button
              mat-stroked-button
              type="button"
              class="btn-guia-visual"
              (click)="onGuiaVisual()"
              [disabled]="!editRegistroForm.controls['Fichero']?.value || !htmlFromListado"
            >
              <mat-icon>photo_library</mat-icon>
              {{ translation.GuiaVisual }}
            </button>
          </div>
        </div>        

        <ng-container *ngIf="editRegistroForm.controls['Fichero']?.value">
          <div class="form-group row">
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation.Nombre }}</mat-label>
  
                <div class="d-flex align-items-center">
                  <input
                    matInput
                    formControlName="Nombre"
                    class="editor-campo-registro"
                  />
                  <mat-icon class="custom-icon material-symbols-outlined" aria-hidden="false" aria-label="Info" [matTooltip]="translation['ImpresionOnlineNombreExample']">info</mat-icon>
                </div>
                <mat-error *ngIf="validateFields('Nombre')">
                  {{ getErrorMessage("Nombre") }}
                </mat-error>
              </mat-form-field>
              <!-- <p class="mt-0"><span>{{ translation.Example }}</span>: INDIVIDUAL, BUTACAS, GRUPOS, ACTIVIDADES, COLEGIOS, GUIA, PROFESIONAL, PROMOS, PASES</p> -->
            </div>
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation.TamanoDePapel }}</mat-label>
                <div class="d-flex align-items-center">
                  <input
                    matInput
                    formControlName="PageSize"
                    class="editor-campo-registro"
                  />
                  <mat-icon class="custom-icon material-symbols-outlined" aria-hidden="false" aria-label="Info" [matTooltip]="translation['ImpresionOnlinePageSizeExample']">info</mat-icon>
                </div>
                <mat-error *ngIf="validateFields('PageSize')">
                  {{ getErrorMessage("PageSize") }}
                </mat-error>
              </mat-form-field>
              <!-- <p><span>{{ translation.Example }}</span>: A4, Letter, Legal</p> -->
            </div>
          </div>
  
          <div class="form-group row">
            <div class="col-sm-12 col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation.Notas }}</mat-label>
                <input
                  matInput
                  formControlName="Notas"
                  class="editor-campo-registro"
                />
                <mat-error *ngIf="validateFields('Notas')">
                  {{ getErrorMessage("Notas") }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
  
          <div class="form-group row">
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation.MargenLeft }}</mat-label>
                <input
                  matInput
                  formControlName="MargenLeft"
                  class="editor-campo-registro"
                />
                <mat-error *ngIf="validateFields('MargenLeft')">
                  {{ getErrorMessage("MargenLeft") }}
                </mat-error>
              </mat-form-field>
              
            </div>
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation.MargenRight }}</mat-label>
                <input
                  matInput
                  formControlName="MargenRight"
                  class="editor-campo-registro"
                />
                <mat-error *ngIf="validateFields('MargenRight')">
                  {{ getErrorMessage("MargenRight") }}
                </mat-error>
              </mat-form-field>
            </div>
          </div> 
  
          <div class="form-group row">
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation.MargenTop }}</mat-label>
                <input
                  matInput
                  formControlName="MargenTop"
                  class="editor-campo-registro"
                />
                <mat-error *ngIf="validateFields('MargenTop')">
                  {{ getErrorMessage("MargenTop") }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation.MargenBottom }}</mat-label>
                <input
                  matInput
                  formControlName="MargenBottom"
                  class="editor-campo-registro"
                />
                <mat-error *ngIf="validateFields('MargenBottom')">
                  {{ getErrorMessage("MargenBottom") }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>     
          
          <div class="form-group row">
            <div class="col-sm-12 col-md-12">
              <mat-form-field appearance="outline">
                <mat-select
                  placeholder="{{ translation.TipoImpresion }}"
                  formControlName="TipoImpresion"
                  name="Fichero"
                >
                  <mat-option
                    *ngFor="let element of tipoImpresion"
                    [value]="element.value"
                  >
                    {{ element.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="validateFields('TipoImpresion')">
                  {{ getErrorMessage("TipoImpresion") }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
  
          <div style="margin: 20px 5px 0 5px; text-align: center">
            <mat-label>{{ translation.EnlaceMenu }}</mat-label>
            
            <customan-dual-list
              [source]="enlacesMenuSinAsignar"
              [(destination)]="enlacesMenuAsignados"
              key="pkId"
              display="Nombre"
              [format]="format"
              [filter]="true"
              [isRightMultiSelection]="false"
              (emitConfirmedItem)="getSelectedEnlaceMenu($event)"
              (destinationChange)="getEmitedMovedEnlacesMenu()"
            >
            </customan-dual-list>
  
            <mat-error *ngIf="(editRegistroForm.controls['EnlacesMenu'].touched || editRegistroForm.controls['EnlacesMenu'].dirty) && validateFields('EnlacesMenu')">
              {{ getErrorMessage("EnlacesMenu") }}
            </mat-error>
          </div>
  
          <div style="margin: 20px 5px 0 5px; text-align: center">
            <mat-label>{{ translation.GruposInternet }}</mat-label>
  
            <customan-dual-list
              [source]="gruposInternetSinAsignar"
              [(destination)]="gruposInternetAsignados"
              key="Id"
              display="Nombre"
              [format]="format"
              [filter]="true"
              (destinationChange)="getEmitedMovedGruposInternet()"
            >
            </customan-dual-list>
          </div>
  
          <div style="margin: 20px 5px 0 5px; text-align: center" *ngIf="editRegistroForm?.controls?.Fichero.value && etiquetasFiltredByIdioma?.length">
            <mat-label>{{ translation.Etiquetas }}</mat-label>
  
            <div class="col-sm-12 col-md-3">
              <mat-form-field appearance="outline">
                <mat-select
                  placeholder="{{ translation.Idioma }}"
                  (selectionChange)="getIdiomaDeEtiqueta($event)"
                  name="Idioma"
                  formControlName="IdiomaDeEtiqueta"
                >
                  <mat-option
                    *ngFor="let idioma of idiomasDeEtiquetas"
                    [value]="idioma.codIdioma"
                  >
                    {{ idioma.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            
            <div formArrayName="Etiquetas">
              <div class="form-group row" *ngFor="let control of editRegistroForm.get('Etiquetas')['controls']; let i = index" [formGroupName]="i">
                <div class="col-sm-12 col-md-6 text-left">
                  <span>{{ control.controls?.Name?.value }}</span>
                </div>

                <ng-container *ngIf="control.controls?.Name?.value?.startsWith(pdfImage) || control.controls?.Name?.value?.startsWith(pdfLogo); else defaultEtiqueta">
                  <div class="col-sm-12 col-md-6">
                    <app-input-with-image-preview 
                      [btnLabel]="translation['DescargarImagen']"
                      [imageBase64]="control.controls?.Value?.value"
                      (emmitImageBase64)="setEtiquetaImageControlValue($event, i)"
                    ></app-input-with-image-preview>
                  </div>
                </ng-container>

                <ng-template #defaultEtiqueta>
                  <div class="col-sm-12 col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ translation.ValorDeLaEtiqueta }}</mat-label>
                      <textarea 
                        matInput
                        formControlName="Value"
                        class="editor-campo-registro" 
                      ></textarea>
                    </mat-form-field>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>         
        </ng-container>
      </form>
    </div>
  </div>
</div>
